import React, { FC } from 'react';
import warningImg from './assets/Warning.png';
import styled from 'styled-components';
import { DetailWrapper, LeftIcon, LeftParagraphWrapper, RowWrapper } from './style';
import { Paragraph } from 'hui';

const UploadFailedWrapper = styled.div`
  margin-top: 2rem;
`;

interface UploadFailedProps {
  detail: string[];
  failReason: string;
}

const UploadFailed: FC<UploadFailedProps> = ({ detail, failReason }) => (
  <UploadFailedWrapper>
    <RowWrapper>
      <LeftIcon alt="warning" src={warningImg} />
      <Paragraph mb={0}>Upload failed</Paragraph>
    </RowWrapper>
    <RowWrapper>
      <LeftParagraphWrapper>
        <Paragraph mb={0} bold>
          Fail reason:
        </Paragraph>
      </LeftParagraphWrapper>
      <Paragraph mb={0}>{failReason}</Paragraph>
    </RowWrapper>
    <DetailWrapper>
      <LeftParagraphWrapper>
        <Paragraph mb={0} bold>
          Detail:
        </Paragraph>
      </LeftParagraphWrapper>
      <div>
        {detail.map(dtl => (
          <Paragraph mb={0} key={Math.random()}>
            {dtl}
          </Paragraph>
        ))}
      </div>
    </DetailWrapper>
  </UploadFailedWrapper>
);

export default UploadFailed;
